<!--
 * @Description:
 * @Date: 2019-03-15 10:04:20
 -->
<template>
  <div>
    <div class="table-box" style="paddingTop:10px">
      <el-button
        @click="back"
        type="text"
        style="display:flex"
        icon="el-icon-arrow-left"
      >
        返回
      </el-button>
      <searchbar :searchEvent="searchEvent.bind(this)" :parent="this" />
      <div>
        <el-table
          style="width: 100%"
          v-loading="loading"
          row-key="questionnaireAnswerId"
          ref="recordList"
          :data="tableData"
          :stripe="false"
          :highlight-current-row="false"
          header-row-class-name="noBorder"
        >
          <!-- <el-table-column
            type="selection"
            width="55"
            row-key="questionnaireAnswerId"
            :reserve-selection="true"
          ></el-table-column> -->
          <el-table-column
            type="index"
            label="序号"
            align="center"
            width="80"
          ></el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            prop="fullName"
            label="项目参与人"
          ></el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            v-if="projectStructureType === 2"
            align="center"
            prop="userEnterpriseName"
            label="个体"
          ></el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            prop="phone"
            label="手机号"
          ></el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            prop="taskCode"
            label="任务编码"
          ></el-table-column>
          <!-- <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            prop="finishDt"
            label="提交时间"
          >
            <template slot-scope="scope">
              {{ scope.row.finishDt | transAllTime }}
            </template>
          </el-table-column> -->
          <!-- <el-table-column :show-overflow-tooltip="true" align="center" label="任务月度">
            <template slot-scope>{{month}}</template>
          </el-table-column> -->
          <!-- <template v-if="tableData[0]">
            <el-table-column
              v-if="tableData[0].isSetTarget"
              align="center"
              width="200px"
              :label="tableData[0].targetTitle"
            >
              <template slot-scope="scope">
                <el-tooltip
                  effect="dark"
                  :content="scope.row.customerName"
                  placement="top"
                  popper-class="custom-tooltip"
                >
                  <span>
                    {{
                      `${scope.row.customerName}`.replace(
                        /(.{100})(.*)/,
                        (str, rA, rB) => {
                          return rB ? rA + '...' : rA;
                        }
                      )
                    }}
                  </span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              v-if="tableData[0].isSetTime"
              align="center"
              width="200px"
              :label="tableData[0].timeTitle"
              prop="customerName"
            >
              <template slot-scope="{ row }">
                <span>{{ row.timeQuestions }}</span>
              </template>
            </el-table-column>
            <el-table-column
              v-if="tableData[0].isSetLocation"
              align="center"
              width="200px"
              :label="tableData[0].locationTitle"
              prop="customerName"
            >
              <template slot-scope="{ row }">
                <el-image
                  style="margin-right: 10px"
                  :src="row.addressPicUrl"
                  :preview-src-list="[row.addressPicUrl]"
                ></el-image>
              </template>
            </el-table-column>
            <template v-if="tableData[0].formatAnswer">
              <el-table-column
                align="center"
                prop="customerName"
                v-for="(item, index) in tableData[0].formatAnswer"
                :key="index"
                :label="item.title"
                width="400px"
              >
                <template slot-scope="{ $index }">
                  <div style="display:flex">
                    <el-image
                      style="margin-right: 10px"
                      v-for="file in tableData[$index].formatAnswer[index].answer"
                      :src="file.url"
                      :key="file.url"
                      :preview-src-list="[file.url]"
                    ></el-image>
                  </div>
                </template>
              </el-table-column>
            </template>
          </template> -->
          <el-table-column
            label="服务商审核人"
            align="center"
            v-if="showReviewer"
          >
            <template slot-scope="scope">
              {{ dealReviewer(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            label="状态"
          >
            <template slot-scope="scope">
              {{ scope.row.auditGongyeStatus | transAuditStatus }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="check(scope.row)">
                查看
              </el-button>
              <el-button
                :disabled="scope.row.auditGongyeStatus !== 1"
                type="text"
                size="small"
                @click="approve(2, scope.row)"
              >
                通过
              </el-button>
              <rejectComponent
                :disabled="scope.row.auditGongyeStatus !== 1"
                @withdraw="item => approve(3, scope.row, 0, item)"
              />
            </template>
          </el-table-column>
        </el-table>
        <!--分页-->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="paginationData.pageNum"
          :total="totalElements"
          :page-size="paginationData.pageSize"
          layout="total, prev, pager, next, jumper"
          style="padding:15px"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { project, receive } from '@/api/ajax';
import { pageInation } from '@/Mixin/listMixin';
import { initSearch } from '@/Mixin/initSearch';
import { makeSure } from '@/Mixin/makeSure';
import dicSelect from '@/components/Common/dicSelect.vue';
import taskRecordHandles from '@/Mixin/taskRecordHandles';
import searchbar from '@/components/Survey/searchbar';
import rejectComponent from '@/components/Task/components/reject.vue';
import OpenNewWin from '@/tools/openNewWin';
import approvalFlagMixins from '@/Mixin/approvalFlagMixins';
import { setStorage, getStorage } from '@/tools/storage';

export default {
  mixins: [pageInation, makeSure, taskRecordHandles, approvalFlagMixins],
  data() {
    return {
      ruleForm: {}, // 用户信息
      getList: project.questMakeSceneBaseProjectAnswerList, // 获取列表的AJAX
      projectStructureType: getStorage('homeProject').projectStructureType || 1,
      searchQuery: {
        projectId: this.$route.query.projectId,
        taskDt: this.$route.query.month,
        projectType: 20,
        statementId: this.$route.query.statementId,
        ...getStorage('recordsearchQuery')
      },
      month: this.$route.query.month
    };
  },
  components: {
    dicSelect,
    searchbar,
    rejectComponent
  },
  computed: {},

  methods: {
    back() {
      localStorage.removeItem('recordsearchQuery');
      this.$router.back();
    },
    formatDataMethod(data) {
      let { list } = data;
      list.forEach(item => {
        let formatAnswer = [];
        let {
          makeSceneMap: { id, ...makeSceneMapOptions },
          topicList
        } = item;

        topicList.forEach(({ type, title, answer }) => {
          if (type === 13) {
            try {
              answer = JSON.parse(answer);
            } catch (e) {}
            formatAnswer.push({
              type,
              title,
              answer
            });
          }
        });

        Object.assign(item, makeSceneMapOptions, {
          formatAnswer
        });
      });
      return data;
    },
    check(item) {
      setStorage('recordsearchQuery', this.searchQuery);
      this.$router.push({
        name: 'editSceneRecordDetail',
        query: {
          ...this.$route.query,
          answerId: item.questionnaireAnswerId,
          sceneBaseId: item.makeSceneBaseId,
          userId: item.userId,
          statementId: this.$route.query.statementId,
          auditGongyeStatus: item.auditGongyeStatus,
          questionnaireAnswerId: item.questionnaireAnswerId
        }
      });
    },
    exportEvent() {
      if (this.searchQuery.projectId && this.searchQuery.taskDt) {
        let queryString = this.$querystring.stringify(this.searchQuery);
        window.open(
          project.taskmakeSceneBaseProjectAnswerPageListExportV2 +
            '?' +
            queryString
        );
      } else {
        this.$message.error('请选择条件');
      }
    }
  },
  created() {}
};
</script>
<style lang="scss" scoped>
.table-box {
  margin: 0;
}
</style>
